import { appendBaseUrl } from "../fork/getPathFromState-mods";
import { stripGroupSegmentsFromPath } from "../router/matchers";
import { useOneRouter } from "../router/router";

function useLinkTo(props) {
	var { linkTo } = useOneRouter();
	return {
		href: appendBaseUrl(stripGroupSegmentsFromPath(props.mask || props.href) || "/"),
		role: "link",
		onPress: function onPress2(e) {
			var event = props.replace ? "REPLACE" : "PUSH";
			var shouldHandle = false;
			shouldHandle = e ? !e.defaultPrevented : true;
			if (shouldHandle) {
				var options = props.mask ? { mask: { href: props.mask } } : void 0;
				linkTo(props.href, event, options);
			}
		}
	};
}

export { useLinkTo };